module.exports = __webpack_public_path__ + "static/antd-table-fixed-header-53c65a683715e85f621ef48d781be0b5.png";